












































































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  QueryRegisters,
  AcceptRegister
} from "@/api/pdOutPatient/pdOutPatientIndex";
import { QueryPdPatients } from "@/api/pdOutPatient/pdBasicInformation";
import PdOutPatientMain from "./main.vue";

@Component({
  components: {
    PdOutPatientMain
  }
})
export default class PdOutPatientIndex extends AbpBase {
  split1: number = 0.2;
  showHeader: boolean = false;
  listWaiting: any[] = [];
  listVisiting: any[] = [];
  modalAcceptRegister: boolean = false;
  currentPatient: any = {};
  currentRegTab = "tabWaiting";
  loading: boolean = false;
  columns = [
    {
      title: "name",
      key: "name",
      align: "center"
    }
  ];

  async getRegisterList() {
    this.loading = true;
    let res = await QueryRegisters();
    this.listWaiting = res.objects;
    this.loading = false;
  }

  async getPatientList() {
    this.loading = true;
    let res = await QueryPdPatients();
    this.listVisiting = res.objects;
    this.loading = false;
  }

  //接诊弹窗
  onWaitRowClick(data: any, index: any) {
    this.currentPatient = data;
    this.modalAcceptRegister = true;
  }

  //患者明细
  onVisitRowClick(data: any, index: any) {
    this.currentPatient = data;
  }

  //接诊
  acceptRegister() {
    AcceptRegister({ Id: this.currentPatient.id }).then(() => {
      this.currentPatient = {};
      this.getData();
    });
  }

  getData() {
    if (this.currentRegTab == "tabWaiting") {
      this.getRegisterList();
    } else {
      this.getPatientList();
    }
  }

  handleClickRegTab(tabName: string) {
    this.currentRegTab = tabName;
    this.getData();
  }

  created() {
    this.getData();
  }

  constructor() {
    super();
    this.$store.dispatch("icd/loadItems");
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdOutPatientIndex/index.vue